import { render, staticRenderFns } from "./RegisterAdditionalModalComponent.vue?vue&type=template&id=0ba6e263&"
import script from "./RegisterAdditionalModalComponent.vue?vue&type=script&lang=ts&"
export * from "./RegisterAdditionalModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports